<template>
  <div id="GoTop" @click="GoTop()">
    <img src="@/assets/img/showiphone.png" alt="">
    <div class="showimg">
      <div class="sanjiao"></div>
      <ul>
        <li v-for="(item,index) in linkData" :key="index">
          <div class="img"><img :src="item.url" alt="" :class="item.class"></div>
          <div>{{item.num}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false,
      linkData: [
        { 
          class: 'showiphone',
          url: require("@/assets/img/showiphone.png"),
          num: '400-150-1007'
        },
        // {
        //   class: 'mobile',
        //   url: require("@/assets/img/mobile.png"),
        //   num: '19884183600'
        // },
        {
          class: 'mess',
          url: require("@/assets/img/mess.png"),
          num: 'bee@joyfinder.com.cn'
        }
      ]
    };
  },
  methods: {
    GoTop() {
      function smoothscroll() {
        var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      };
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 80px;
  height: 80px;
  position: fixed;
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgba(3, 80, 194, 0.25);
  border-radius: 20px;
  right: 20px;
  bottom: 90px;
  z-index: 99999999;
  cursor: pointer;
  text-align: center;
}
#GoTop:hover .showimg{
  display: block;
}
img {
  width: 36px;
  height: 36px;
  margin: 22px;
}
.showimg {
  display: none;
  width: 250px;
  height: 155px;
  padding: 20px;
  background: #FFFFFF;
  box-shadow: 6px 6px 24px rgba(3, 80, 194, 0.25);
  border-radius: 40px;
  position: fixed;
  right: 140px;
  bottom: 40px;
  z-index: 99999999;
}
.sanjiao {
  width: 0px;
  height: 0px;
  border: 19px solid transparent;
  border-left-color: white;
  position: fixed;
  right: 103px;
  bottom: 110px;
}
ul li {
  display: flex;
  height: 42px;
}
ul li div {
  font-size: 16px;
  line-height: 30px;
  color: #272727;
}
.showiphone {
  width: 30px;
  height: 30px;
  margin: 0;
  margin-right: 24px;
  margin-left: 2px;
  padding: 0;
}
.mobile {
  width: 25px;
  height: 33px;
  margin: 0;
  margin-right: 24px;
  margin-left: 4px;
  padding: 0;
}
.mess {
  width: 33px;
  height: 26px;
  margin: 0;
  margin-right: 21px;
  margin-left: 0px;
  padding: 0;
}
/* 媒体查询（手机） */
@media screen  and (max-width: 768px) {
  #GoTop {
    display: none;
  }
}
@media screen and (min-width: 768px) and (max-width: 996px){
  #GoTop { 
    display: none;
  }
}
</style>
